import { memo, useState } from 'react';
import { LoanService } from '../../services';
import { useError } from '../../contexts/ErrorContext';
import { useNotification } from '../../contexts/NotificationContext';
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import ConfirmationModal from '../../components/ConfirmationModal';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import LoadingModal from '../../components/LoadingModal';
import { LOAN_HOLD_STATUS } from '../../utils/constants';

const BulkRemovePendingReleaseButton = ({selectedRowIndices, holds, currentDate}) => {
  const [showRemovePendingReleaseConfirmation, setShowRemovePendingReleaseConfirmation] = useState(false);
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const { showError } = useError();
  const { createErrorNotification } = useNotification();

  const toggleRemovePendingReleaseConfirmation = () =>
    setShowRemovePendingReleaseConfirmation(!showRemovePendingReleaseConfirmation);
  const openLoadingModal = () => setShowLoadingModal(true);
  const closeLoadingModal = () => setShowLoadingModal(false);

  // Bulk remove pending release is exclusively available for loans already pending release.
  const selectedHolds = selectedRowIndices.map(rowId => holds[rowId]);
  const allPendingRelease = selectedHolds.length > 0 &&
    selectedHolds.every(hold => hold.holdStatus === LOAN_HOLD_STATUS.PENDING_RELEASE);

  if (!allPendingRelease) {
    return null;
  }

  const handleRemovePendingReleaseClick = () => {
    if (!currentDate) {
      createErrorNotification('You can only modify holds for current date');
      return;
    }
    toggleRemovePendingReleaseConfirmation();
    openLoadingModal();
    LoanService.bulkRemovePendingRelease(selectedHolds.map(hold => hold.loanNumber)).then(response => {
      window.location.reload();
    }).catch(showError)
      .finally(() => {
        closeLoadingModal();
    });
  }

  return (
    <>
      <Tooltip title={currentDate ? 'Bulk Remove Pending Release Selected Loans' : 'You can only modify holds for current date'}>
        <IconButton onClick={toggleRemovePendingReleaseConfirmation} >
          <RemoveCircleIcon />
        </IconButton>
      </Tooltip>
      <ConfirmationModal title="Confirm" message="Are you sure you want to remove these loans from pending release? They will return to hold for funding." onConfirm={handleRemovePendingReleaseClick} onCancel={toggleRemovePendingReleaseConfirmation} showConfirmationBox={showRemovePendingReleaseConfirmation}/>
      <LoadingModal open={showLoadingModal} />
    </>
  );
}

export default memo(BulkRemovePendingReleaseButton);
